import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FaStar, FaRegStar, FaStarHalfAlt } from "react-icons/fa";
import { MdVerified } from "react-icons/md";
import { FaStethoscope } from "react-icons/fa6";
import { TbStarsFilled } from "react-icons/tb";
// import { CiLocationOn } from "react-icons/ci";
import { BsCashCoin } from "react-icons/bs";
import { FaPhone } from "react-icons/fa6";
import { VscWatch } from "react-icons/vsc";
import { IoMdClose } from "react-icons/io";
import { RiSpeakFill } from "react-icons/ri";
import { FaLocationDot } from "react-icons/fa6";

import defaultImg from '../../Assets/defaultImg.png'

import AwardsCarousel from "./AwardCarousal";
import AvailabilityCarousel from "./AvailabilityCarousel";
import './DoctorsGridPageCss/DoctorDetailsPage.css';

import PatientStories from "./PatientStoriesSection";

import useIsMobile from "../../Hooks/IsmobileHook";
import { getDoctorInfo } from "../../api/api";

export default function DoctorDetailsPage({ doctor, onClose }) {
    const isMobile = useIsMobile();
    const [activeTab, setActiveTab] = useState("Doctor Bio");
    const [showFullBio, setShowFullBio] = useState(false);
    const [doctorData, setDoctorData] = useState([]);

    const detailsTabs = ["Doctor Bio", 
        // "Availability", 
        "Rating", "Stories"];


    console.log("chk dr details", doctor);


    useEffect(() => {
        fetchDoctorData();

    },[])

    const fetchDoctorData = async () => {
        const payload = { doctorId: doctor?.doctor_id };
        try {
            const response = await getDoctorInfo(payload);
            setDoctorData(response?.data?.doctorRating);
            console.log("calling response of dr info",response);
        } catch (error) {
            console.error("Error fetching doctor data:", error);
        }
    };

    const ratingsData = doctorData?.length ? [
  { stars: 5, feedbackCount: doctorData[0].count_5 },
  { stars: 4, feedbackCount: doctorData[0].count_4 },
  { stars: 3, feedbackCount: doctorData[0].count_3 },
  { stars: 2, feedbackCount: doctorData[0].count_2 },
  { stars: 1, feedbackCount: doctorData[0].count_1 },
] : [];

    const renderTabContent = () => {
        switch (activeTab) {
            case "Doctor Bio":

                const bioWords = doctor.AboutDoctor?.split(" ") || [];
                const shouldTruncate = bioWords.length > 30;
                const displayedBio = showFullBio ? doctor.AboutDoctor : bioWords.slice(0, 30).join(" ") + "...";

                return (
                    <div className="doctorDetailsPara">
                        <p className="doctorBio">{displayedBio}</p>
                        {shouldTruncate && (
                            <button
                                className="readMoreBtn"
                                onClick={() => setShowFullBio(!showFullBio)}
                                style={{
                                    background: "none",
                                    color: "#0CA798",
                                    border: "none",
                                    cursor: "pointer",
                                    padding: 0,
                                    fontWeight: "bold",
                                    display: "flex",
                                    justifyContent: "center"
                                }}
                            >
                                {showFullBio ? "Read Less" : "Read More"}
                            </button>
                        )}
                        <br />
                        <strong>Training</strong>
                        <p className="doctorBio">{doctor.Training || "No Data is Found"}</p>
                    </div>
                );
            case "Stories":
                return (
                    <div className="storiesSection">
                        <PatientStories stories={doctorData?.[0]?.patientStories|| ''} />

                        {doctorData?.[0]?.patientStories && (
        <div className="verifiedBadge">
          <MdVerified /> Verified
        </div>
      )}
                        
                    </div>
                );
            // case "Availability":
            //     return (
            //         <div className="availabilitySection">
            //             <AvailabilityCarousel />
            //         </div>
            //     );
            case "Awards":
                return (
                    <div className="awardsSection">
                        <AwardsCarousel awards={doctor.Awards} />
                    </div>
                );
            case "Rating":
  return (
    <div className="ratingCountSection">
      <h3>Average Rating: {doctor?.doctorWiseAvgRating ?? 0}</h3>
      
      {ratingsData.map((rating, index) => (
        <div key={index} className="ratingRow">
          <div className="stars">
            {[...Array(5)].map((_, i) => (
              <FaStar
                key={i}
                className={i < rating.stars ? "star filled" : "star"}
              />
            ))}
            <span className="count">({rating.feedbackCount || 0})</span>
          </div>
          <div className="feedbackCount">{rating.feedbackCount || 0} Feedbacks</div>
        </div>
      ))}
    </div>
  );

            default:
                return null;
        }
    };

    const fullStars = parseInt(doctor.rating);
    const halfStar = doctor.rating - fullStars >= 0.5;
    const maxStars = 5;



    const navigator = useNavigate();

    const handleBookAppointment = (doctorInfo) => {
        console.log(doctorInfo);

        navigator('/appointment/date-and-time', { state: { doctor: doctorInfo } });
    };


    return (
        <div className="modal-overlay">
            <div className="modal-content doctorDetailsPageContainer">
                <button className="close-modal-btn" onClick={onClose}><IoMdClose size={24} /></button>

                {/* Upper Section */}
                <div className="doctorDetailsPageUpperSection">
                    <img src={doctor.DoctorPictureUrl || defaultImg} alt={doctor.doctor_name} className="doctorImage" />

                    <div className="doctorDetailsUpperMiddleSection">
                        <h1 className="doctorName">
                            {`DR.${doctor.doctor_name}`} <span className="verifiedTick"><MdVerified /></span>
                        </h1>

                        <div className="ratingSection">
                            {/* <span className="stars">
                                {[...Array(fullStars)].map((_, i) => (
                                    <FaStar key={`full-${i}`} color="#0ca798" />
                                ))}
                                {halfStar && <FaStarHalfAlt color="#0ca798" />}
                                {[...Array(maxStars - fullStars - (halfStar ? 1 : 0))].map((_, i) => (
                                    <FaRegStar key={`empty-${i}`} color="#ccc" />
                                ))}
                            </span> */}
                            {/* <p>{doctor.rating}<a href="#reviews">{doctor.reviews} Reviews</a></p> */}
                            <p>{doctor?.avgRating}<a href="#reviews">{doctor.reviews} Reviews</a></p>
                        </div>

                        {
                            isMobile ? <>
                                <div className="doctorHighlights">
                                    <div className="topDoctorHighlight">
                                        <p><FaStethoscope style={{ color: "rgb(24, 79, 123)" }} /> {doctor.specialization}</p>
                                        <p>
                                            <TbStarsFilled style={{ color: "rgb(141, 77, 75)" }} /> {doctor.experience} Yrs Exp.
                                        </p>
                                    </div>
                                    <div className="topDoctorlowlight">
                                        <p><FaLocationDot style={{ color: "rgb(58, 145, 116)" }} /> {doctor?.centers.map((item) => item.center_name).join(", ")}</p>
                                        <p style={{ fontSize: "1.3rem", fontWeight: 'bold' }}>
                                            <BsCashCoin style={{ color: "rgb(194, 80, 31)" }} /> <span style={{ color: "#0CA798" }}>₹{doctor?.centers?.[0]?.Fees || 0}/-</span>
                                        </p>
                                    </div>
                                </div>
                            </> : <>
                                <div className="doctorHighlights">
                                    <p><FaStethoscope style={{ color: "rgb(24, 79, 123)" }} /> {doctor.specialization}</p>
                                    <p>
                                        <TbStarsFilled style={{ color: "rgb(141, 77, 75)" }} /> {doctor.experience} Yrs Exp.</p>
                                    <p><FaLocationDot style={{ color: "rgb(58, 145, 116)" }} /> {doctor?.centers.map((item) => item.center_name).join(", " )}</p>
                                    <p style={{ fontSize: "1.3rem", fontWeight: 'bold' }}>
                                        <BsCashCoin style={{ color: "rgb(194, 80, 31)" }} /> <span style={{ fontSize: "1.3rem", color: "#0CA798" }}>₹{doctor?.centers?.[0]?.Fees || 0}/-</span> Consultant Fee</p>
                                </div>
                            </>
                        }


                    </div>
                    <div className="doctorDetailsUpperRightSection">
                        <div className="doctorDetailsUpperRightText">
                            <div className="iconWithText">
                                <div className="texticonCircle"><VscWatch color="rgb(16, 110, 79)" size="1.5rem" /></div>
                                <p className="availableText">{doctor.availableDays?.join(", ")}</p>
                            </div>
                            {/* <div className="iconWithText">
                                <div className="texticonCircle"><RiSpeakFill color="rgb(16, 110, 79)" size="1.5rem" /></div>
                                <p className="availableText">{doctor.languages?.join(", ")}</p>
                            </div> */}
                            <div className="iconWithText">
                                <div className="texticonCircle"><FaPhone color="rgb(16, 110, 79)" /></div>
                                <p className="availableText" style={{ fontWeight: "900" }}>033-4085-4085</p>
                            </div>
                            {/* <p className="doctorPhone"><FaPhone /> {doctor.contact}</p> */}
                        </div>

                        <div className="doctorDetailsUpperButton">
                            <button className="bookAppointmentBtn rbdButton" onClick={() => handleBookAppointment(doctor)}><span className="btn-text">BOOK APPOINTMENT</span></button>
                        </div>
                    </div>
                </div>

                {/* Tabs */}
                <div className="doctorDetailsTabs">
                    {detailsTabs.map((tab) => (
                        <button
                            key={tab}
                            className={`doctorTabButton ${activeTab === tab ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                {/* Tab Content */}
                <div className="doctorTabContent">
                    {renderTabContent()}
                </div>
            </div>
        </div>
    );
}
